import getParentKey from './getParentKey';

export { getParentKey };
